import { useMemo } from 'react';

import { ResponsivePie } from '@nivo/pie';
import theme from '../../../styles/themes/default';

import { PropagateLoader } from 'react-spinners';
import { Container } from './styles';

interface IData {
  value: number;
  label: string;
}

type DataWithColor =
  | {
      id?: string | undefined;
      color?: string | undefined;
      value: number | undefined;
      label: string | undefined;
    }[]
  | null;

interface IChartPieRadialCardProps {
  data: IData[] | undefined;
  isLoading: boolean;
  isFetching: boolean;
  title: string;
  error: unknown;
}

export const ChartPieRadialCard = ({
  data,
  isLoading,
  title,
  error,
  isFetching,
}: IChartPieRadialCardProps) => {
  const arrayOfColors = [
    theme.colors.orange.primary,
    theme.colors.green.primary,
    theme.colors.blue.primary,
    theme.colors.yellow.light,
    theme.colors.yellow.pressing,
    theme.colors.orange.primary,
    theme.colors.yellow.primary,
    theme.colors.attention,
    theme.colors.yellow.light,
    theme.colors.yellow.pressing,
    theme.colors.orange.primary,
    theme.colors.yellow.primary,
    theme.colors.attention,
    theme.colors.yellow.light,
    theme.colors.yellow.pressing,
  ];

  const dataWithColor: DataWithColor = useMemo(
    () =>
      data?.map((d, index) => ({
        ...d,
        color:
          theme.colors.byUf[d.label as keyof typeof theme.colors.byUf] ||
          arrayOfColors[index],
        id: d?.label,
      })) || null,
    [data],
  );

  return (
    <Container>
      {(isLoading || isFetching) && <h3>Carregando...</h3>}
      {error! && <h3>Falha ao carregar dados.</h3>}

      {(!isLoading || !isFetching) && data && data?.length > 0 && (
        <h3>{title}</h3>
      )}

      {!isLoading && !isFetching && (!data || data?.length === 0) && (
        <h3>'Não encontramos dados para sua pesquisa.'</h3>
      )}

      {!isLoading && !isFetching ? (
        <section>
          <div className="chart">
            <ResponsivePie
              data={dataWithColor || [{ value: 0, label: '' }]}
              margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
              fit
              activeOuterRadiusOffset={8}
              colors={{ datum: 'data.color' }}
              enableArcLinkLabels={false}
              arcLabelsSkipAngle={25}
              motionConfig="default"
              arcLabelsRadiusOffset={0.85}
              theme={{
                text: {
                  fontSize: 16,
                  fill: '#FFF',
                },
              }}
            />
          </div>
          <div className="legendContainer">
            <div className="lines">
              {dataWithColor?.map((item) => (
                <div className="line" key={Math.random()}>
                  <div style={{ backgroundColor: item.color }} />
                  <p>{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : (
        <aside style={{ height: '100%' }}>
          <PropagateLoader size={20} />
        </aside>
      )}
    </Container>
  );
};
